import React from 'react';

import useDeviceSettingHolderGuard from '../../hooks/useDeviceSettingHolderGuard';
import DeviceSettingLayout from '../DeviceSettingLayout/DeviceSettingLayout';
import DeviceSettingsSwitchItem from '../DeviceSettingLayout/DeviceSettingsSwitchItem';
import NoHolderBanner from '../NoHolderBanner/NoHolderBanner';

const SwitchSetting = ({useSettingHook, settingType}) => {
    const {value, onChange, onSave, icon, title, popup, popupCurrentValue} = useSettingHook();
    const {shouldShowNoHolderBanner, shouldDisableInputs, shouldDisableSaveButton, onDisabledSaveClick} =
        useDeviceSettingHolderGuard(settingType);

    if (!popup) return null;

    const {connectButton, primaryButton, description} = popup;

    return (
        <DeviceSettingLayout
            footer={
                <DeviceSettingLayout.ConnectButtonContainer
                    connectButton={connectButton}
                    primaryButton={primaryButton}
                    isDisabled={shouldDisableSaveButton}
                    onPrimaryButtonClick={onSave}
                    onDisableClick={onDisabledSaveClick}
                />
            }
        >
            <DeviceSettingLayout.Header icon={icon} title={title} description={description} />
            {shouldShowNoHolderBanner && <NoHolderBanner className='mt-4' />}
            <DeviceSettingLayout.SwitchContainer>
                <DeviceSettingsSwitchItem
                    title={popupCurrentValue?.icon?.title}
                    isActive={value}
                    onChange={onChange}
                    isDisabled={shouldDisableInputs}
                    onDisabledClick={onDisabledSaveClick}
                />
            </DeviceSettingLayout.SwitchContainer>
        </DeviceSettingLayout>
    );
};

export default SwitchSetting;
